import { render, staticRenderFns } from "./DeliveryOrigin.vue?vue&type=template&id=06fbe6b3&"
import script from "./DeliveryOrigin.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports